export default {
  storyboardScreens: [
    {
      imageFile: "04-Shop_Persona.jpg",
      title: "Purchase Decision Support",
      text:
        "Click NEXT to learn about the importance of timely customer service and support.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "SH04",
      hasNext: true,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04c-Shop_651.jpg",
      title: "Purchase Decision Support",
      text:
        "She decides to take a look at the product reviews. The dress has a high rating, but some customers have said the sizing runs a bit small.",
      coordinates: { left: "746", top: "618", right: "13", bottom: "4" },
      screenId: "SH04c",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04d-Shop_651.jpg",
      title: "Virtual Agent",
      text:
        "Determined to ensure the perfect fit, Lisa opens a chat with a virtual agent on the site.",
      coordinates: { left: "627", top: "110", right: "68", bottom: "139" },
      screenId: "SH04d",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "04e-Shop_651.jpg",
      title: "Virtual Agent",
      text:
        "She realizes it's a chatbot and feels skeptical, but she wants to get help fast so she provides her email address.",
      coordinates: { left: "627", top: "110", right: "68", bottom: "139" },
      screenId: "SH04e",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "04f-Shop_651.jpg",
      title: "Virtual Agent",
      text:
        "The chatbot identifies her based on her email. Lisa is pleasantly surprised.",
      coordinates: { left: "627", top: "110", right: "68", bottom: "139" },
      screenId: "SH04f",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "04g-Shop_651.jpg",
      title: "Virtual Agent",
      text: "Lisa explains her concerns with the dress sizing.",
      coordinates: { left: "627", top: "110", right: "68", bottom: "139" },
      screenId: "SH04g",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "04h-Shop_651.jpg",
      title: "Virtual Agent",
      text:
        "The virtual agent sends her a sizing chart and recommends the dress size to order based on her measurements.",
      coordinates: { left: "627", top: "110", right: "68", bottom: "139" },
      screenId: "SH04h",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "04i-Shop_651.jpg",
      title: "Virtual Agent",
      text:
        "Lisa realizes she's between two sizes and lets the virtual agent know.",
      coordinates: { left: "627", top: "110", right: "68", bottom: "139" },
      screenId: "SH04i",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "04j-Shop_651.jpg",
      title: "Virtual Agent",
      text:
        "The virtual agent connects Lisa to a live agent for further assistance.",
      coordinates: { left: "627", top: "110", right: "68", bottom: "139" },
      screenId: "SH04j",
      hasNext: false,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "04k-Shop_Persona.jpg",
      title: "Customer Service Agent",
      text:
        "Click NEXT to explore the tools live agents use to enable meaningful customer conversations.",
      coordinates: { left: "", top: "", right: "", bottom: "" },
      screenId: "SH04k",
      hasNext: true,
      highlightPosition: "Top-Left"
    },
    {
      imageFile: "04l-Shop_651.jpg",
      title: "Agent Desktop",
      text:
        "The live agent accepts the request and the session details open automatically.",
      coordinates: { left: "760", top: "612", right: "184", bottom: "3" },
      screenId: "SH04l",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04m-Shop_651.jpg",
      title: "Agent Desktop",
      text:
        "The agent reviews the conversation between Lisa and the virtual agent.",
      coordinates: { left: "353", top: "161", right: "404", bottom: "107" },
      screenId: "SH04m",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04n-Shop_651.jpg",
      title: "Agent Desktop",
      text:
        "Then the agent jumps right into the conversation and confirms Lisa’s request.",
      coordinates: { left: "291", top: "162", right: "331", bottom: "105" },
      screenId: "SH04n",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04o-Shop_651.jpg",
      title: "Agent Desktop",
      text:
        "The agent looks at the personal details on file in Lisa’s account.",
      coordinates: { left: "196", top: "172", right: "715", bottom: "447" },
      screenId: "SH04o",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04p-Shop_651.jpg",
      title: "Agent Desktop",
      text:
        "She sees that Lisa had purchased another dress in the collection, which helps her estimate the best size for Lisa to choose for the rose petal dress.  ",
      coordinates: { left: "761", top: "612", right: "185", bottom: "4" },
      screenId: "SH04p",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04q-Shop_651.jpg",
      title: "Agent Desktop",
      text: "She returns to the chat and makes an informed recommendation.",
      coordinates: { left: "611", top: "161", right: "9", bottom: "105" },
      screenId: "SH04q",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04r-Shop_651.jpg",
      title: "Agent Desktop",
      text: "Lisa is happy with the agent's suggestion.",
      coordinates: { left: "933", top: "555", right: "21", bottom: "67" },
      screenId: "SH04r",
      hasNext: false,
      highlightPosition: "Top-Right"
    },
    {
      imageFile: "04s-Shop_651.jpg",
      title: "Agent Desktop",
      text:
        "Once Lisa’s request is fully resolved, the agent saves and closes the chat.",
      coordinates: { left: "393", top: "484", right: "392", bottom: "93" },
      screenId: "SH04s",
      hasNext: false,
      highlightPosition: "Top-Right"
    }
  ]
};
